import "./section-title.scss";

// All the heading and sub-heading of about, projects, skills, and contact
const SectionTitle = ({ subtitle, title }) => {
  return (
    <div className="section-title-container">
      <span className="sub-title">{subtitle}</span>

      <h2 className="section-title">
        {title.split("").map((char, index) => (
          <span key={index} className="letter">
            {char === " " ? "\u00A0" : char}
          </span>
        ))}
      </h2>
    </div>
  );
};

export default SectionTitle;
